(function() {
  function checkAndSanitizeCart() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(async (cart) => {
        if (!cart.items.length) return;

        // 1. Identify items with "Free Gift" properties
        const itemsToSanitize = [];
        cart.items.forEach(item => {
          const props = item.properties || {};
          const hasGiftProps = Object.keys(props).some(k => 
            /^Free Gift/i.test(k) || /^_FreeGiftVariantId/i.test(k)
          );
          if (hasGiftProps) {
            itemsToSanitize.push(item);
          }
        });

        if (!itemsToSanitize.length) return;

        // 2. For each suspect item, fetch its product page HTML to see if gift blocks are active
        const uniqueHandles = [...new Set(itemsToSanitize.map(i => i.handle))];
        const statusMap = {}; // handle -> boolean (true = gifts enabled, false = disabled)

        await Promise.all(uniqueHandles.map(async (handle) => {
          try {
            // Fetch the section with ID "main". Cache-busting with timestamp.
            const url = `/products/${handle}?section_id=main&_t=${Date.now()}`;
            const html = await fetch(url).then(r => r.text());
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            
            // Debugging: Log what we found
            // console.log(`Checking gifts for ${handle}`, html.length);

            // Check for Free Product blocks (both types)
            const freeBlock = doc.querySelector('.free-product, .free-accessories');
            const hasFreeBlock = !!freeBlock;
            
            // console.log(`Handle: ${handle}, Has Block: ${hasFreeBlock}`);
            
            statusMap[handle] = hasFreeBlock;
          } catch (e) {
            // console.error("Error checking gift status", e);
            statusMap[handle] = true; 
          }
        }));

        // 3. Filter items that need sanitization (i.e., belong to products where gifts are now disabled)
        const ops = [];
        itemsToSanitize.forEach(item => {
          if (statusMap[item.handle] === false) { // Explicitly false means confirmed disabled
             const props = item.properties || {};
             const sanitizedProps = {};
             Object.keys(props).forEach(k => {
               if (!(/^Free Gift/i.test(k) || /^_FreeGiftVariantId/i.test(k))) {
                 sanitizedProps[k] = props[k];
               }
             });
             ops.push({ item, sanitizedProps });
          }
        });

        if (!ops.length) return;

        // 4. Execute sanitization (Add clean item, remove dirty item)
        // We do this serially to ensure cart consistency
        for (const op of ops) {
          // Add clean version
          await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({
              items: [{
                id: op.item.variant_id,
                quantity: op.item.quantity,
                properties: Object.keys(op.sanitizedProps).length ? op.sanitizedProps : undefined,
                selling_plan: op.item.selling_plan_id || undefined
              }]
            })
          });
          
          // Remove dirty version
          await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ id: op.item.key, quantity: 0 })
          });
        }

        // 5. Refresh page or cart UI
        // If we are on cart page, reload to show changes. 
        // If in drawer, we might need to trigger a refresh event.
        if (window.location.pathname.includes('/cart')) {
          window.location.reload();
        } else {
          // Try to refresh cart drawer if available
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && cartDrawer.renderContents) {
            // Re-fetch cart section
            fetch(`${window.routes.cart_url}?section_id=cart-drawer`)
              .then(r => r.text())
              .then(text => {
                 const parser = new DOMParser();
                 const doc = parser.parseFromString(text, 'text/html');
                 // This depends on how the theme's cart drawer handles updates.
                 // Often dispatching an event is safer.
                 document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
                 // Or brute-force reload if drawer doesn't auto-update
                 // window.location.reload(); 
              });
          }
          // Dispatch generic update for other listeners
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));
        }
      });
  }

  // Run on page load (Cart page or any page with cart drawer)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAndSanitizeCart);
  } else {
    checkAndSanitizeCart();
  }
})();
